import { render, staticRenderFns } from "./CustomerLevelList.vue?vue&type=template&id=cd2bbdd2&"
import script from "./CustomerLevelList.vue?vue&type=script&lang=js&"
export * from "./CustomerLevelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports